import { formatDate, getStatusConfig } from './utils';

interface TermsTabProps {
  project: Api.Project.ProjectDetailResponse;
}

export default function TermsTab({ project }: TermsTabProps) {
  const channels = project.channels || [];

  if (channels.length === 0) {
    return (
      <div className="py-8 text-center text-foreground-400 text-sm">
        <i className="ri-file-info-line text-2xl block mb-2 text-foreground-300"></i>
        暂无分渠道合作条款数据
      </div>
    );
  }

  return (
    <div>
      <h3 className="font-semibold text-foreground-950 text-sm mb-2">分渠道合作条款</h3>
      <p className="text-xs text-foreground-500 mb-6">以下合作条款经双方确认后生效，如条款有变更需双方再次确认</p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200/70">
              <th className="text-left py-3 px-4 text-xs font-medium text-foreground-500">发行渠道</th>
              <th className="text-left py-3 px-4 text-xs font-medium text-foreground-500">发行地区</th>
              <th className="text-left py-3 px-4 text-xs font-medium text-foreground-500">语言</th>
              <th className="text-left py-3 px-4 text-xs font-medium text-foreground-500">收益分成 (内容方:平台)</th>
              <th className="text-left py-3 px-4 text-xs font-medium text-foreground-500">生效范围/发布时间</th>
              <th className="text-left py-3 px-4 text-xs font-medium text-foreground-500">扣除成本</th>
              <th className="text-left py-3 px-4 text-xs font-medium text-foreground-500">状态</th>
            </tr>
          </thead>
          <tbody>
            {channels.map((row, idx) => {
              const ownerRate = row.owner_share_rate !== undefined ? `${row.owner_share_rate}%` : '-';
              const platformRate = row.platform_share_rate !== undefined ? `${row.platform_share_rate}%` : (row.owner_share_rate !== undefined ? `${100 - row.owner_share_rate}%` : '-');
              const statusInfo = getStatusConfig(row.status);
              const regionText = row.region?.name || row.region_code || '-';
              const languagesText = row.languages && row.languages.length > 0
                ? row.languages.map((l) => l.name || l.code).filter(Boolean).join('、')
                : (row.language_codes && row.language_codes.length > 0 ? row.language_codes.join('、') : '-');

              return (
                <tr key={row.id || idx} className="border-b border-background-200/50">
                  <td className="py-3 px-4 font-medium text-foreground-900">{row.channel?.name || '默认渠道'}</td>
                  <td className="py-3 px-4 text-foreground-700">{regionText}</td>
                  <td className="py-3 px-4 text-foreground-700">{languagesText}</td>
                  <td className="py-3 px-4 text-foreground-700">{ownerRate} : {platformRate}</td>
                  <td className="py-3 px-4 text-foreground-700">
                    {row.share_effective_from ? formatDate(row.share_effective_from) : (row.online_at ? formatDate(row.online_at) : '即时生效')}
                  </td>
                  <td className="py-3 px-4 text-foreground-700">
                    {row.deduct_before_share ? '分成前扣除' : '无'}
                  </td>
                  <td className="py-3 px-4">
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusInfo.color}`}>
                      {statusInfo.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="mt-6 p-4 rounded-xl bg-gray-50 border border-gray-200/60">
        <p className="text-xs text-foreground-500">
          <i className="ri-information-line text-secondary-500 mr-1"></i>
          以上条款已于 {formatDate(project.created_at)} 经双方确认，如需修改请联系平台运营。
        </p>
      </div>
    </div>
  );
}
